import { FCElement } from '@fc/component';
import { debounce } from '@fc/utilities';

const ESC_DEBOUNCE_MS = 100;
const ESCAPE_KEY = 'Escape';

// Search input with clear button and Escape-key support
class SearchPageInputComponent extends FCElement {
  requiredRefs = ['searchPageInput'];

  handleClearClick() {
    this.#resetInputAndSubmit();
  }

  handleKeyDown = debounce((event) => {
    if (event.key !== ESCAPE_KEY) return;

    // Predictive search owns Escape while its dropdown is open.
    if (event.defaultPrevented) return;

    const input = this.#getSearchInput();
    if (!input || input.value.trim() === '') return;

    event.preventDefault();
    this.#resetInputAndSubmit();
  }, ESC_DEBOUNCE_MS);

  #getSearchInput() {
    const input = this.refs.searchPageInput;
    return input instanceof HTMLInputElement ? input : null;
  }

  #resetInputAndSubmit() {
    const input = this.#getSearchInput();
    if (!input) return;

    requestAnimationFrame(() => {
      input.focus();
      input.value = '';

      // Skip resubmission when already showing empty results
      if (this.#hasBlankQueryInUrl()) return;

      input.form?.submit();
    });
  }

  #hasBlankQueryInUrl() {
    try {
      return (new URL(location.href).searchParams.get('q') ?? '').trim() === '';
    } catch {
      return false;
    }
  }
}

if (!customElements.get('search-field')) {
  customElements.define('search-field', SearchPageInputComponent);
}
